import { ReportsApiClient } from '@fourthwall/services/dist/ReportsApiClient';
import { useMutation } from '@tanstack/react-query';
import { exportReportCSV } from '../utils/exportReportCSV';
import { useAnalyticsQueryParams } from './useAnalyticsQueryParams';
export const useExportAnalyticsReportCSV = () => {
    const analyticsQueryParams = useAnalyticsQueryParams();
    const { mutateAsync } = useMutation({
        mutationFn: async (params) => {
            const { data } = await ReportsApiClient.getReportCSV(...params);
            return data;
        },
    });
    const handleExport = async (reportId) => {
        const data = await mutateAsync([{ id: reportId }, analyticsQueryParams]);
        if (data) {
            exportReportCSV(data, `${reportId}.csv`);
        }
    };
    return {
        exportReportCSV: handleExport,
    };
};
